// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import moment from 'moment'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getCardIcon, handlingPermitServiceCriteria, isPermissionExist, phoneMasker, sortPortalPermissionByKey, removeDubleComma, shouldShowVehicleColumn, formatDecimal, isZeroAmount } from '../../utils/helper'
import queryString from 'query-string'
// import { saveBookingAfterPayment } from '../../redux/actions/paymentActions'
import { useNavigate } from 'react-router-dom'
// import URL from '../../constants/urls'
import { Circles } from 'react-loader-spinner'
import { systemError } from '../../Global/Constant'
import { Col, Row } from 'react-bootstrap'
import PassWalletButtons from '../../components/global/PassWalletButtons'
import { APICONFIG } from '../../redux/config/apiConfig'
import useMobileView from '../../Hooks/useMobileView'
import { QRCodeSVG } from 'qrcode.react'


function ThankYou(props) {
	const { response, paymentStatus, paymentResponse, isLoading, notify } = props
	const [bookingType, setBookingType] = useState('')
	const [paymentSession, setPaymentSession] = useState(EMPTY_OBJECT)
	const [queries, setQueries] = useState(EMPTY_OBJECT)
	const navigate = useNavigate()
	const partner = window.location.toString().split('/')[3]
	const zone = localStorage.getItem('zone')
	const [isphone, setIsPhone] = useState('')
	const [accessPermissions, setAccessPermissions] = useState('')
	const [displayVehicle, setDisplayVehicle] = useState(false)

	const CardNumberLast4 = localStorage.getItem('CardNumberLast4') ? localStorage.getItem('CardNumberLast4') : ''
	const expiration_date = localStorage.getItem('expiration_date') ? localStorage.getItem('expiration_date') : ''
	const card_type = localStorage.getItem('card_type') ? localStorage.getItem('card_type') : ''
	const partnerDetials = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : '{}'
	const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
	const isMobile = useMobileView()

	const searchParams = new URLSearchParams(location.search)

	useEffect(() => {

		//setPage('thankyou')
		window.scrollTo(0, 0)
		let queries = queryString.parse(location.search)
		const bookTypeData = localStorage.getItem('bookingType')
		setBookingType(bookTypeData)
		setQueries(queries)
		// const beforePaymentPayload = JSON.parse(localStorage.getItem('beforePaymentPayloadValue'))
		const paymentSession = localStorage.getItem('paymentSession') ? JSON.parse(localStorage.getItem('paymentSession')) : null
		setPaymentSession(paymentSession)
		// const payloadafterPayment = {
		// 	'facility_id': beforePaymentPayload?.facility_id,
		// 	'license_number': beforePaymentPayload?.license_number,
		// 	'first_name': beforePaymentPayload?.firstname,
		// 	'last_name': beforePaymentPayload?.lastname,
		// 	'password': beforePaymentPayload?.password ? beforePaymentPayload?.password : '',
		// 	'confirm_password': beforePaymentPayload?.cpassword ? beforePaymentPayload?.cpassword : '',
		// 	'email': beforePaymentPayload?.email,
		// 	'phone': beforePaymentPayload?.phone,
		// 	'city': beforePaymentPayload?.city,
		// 	'state': beforePaymentPayload?.state,
		// 	'zipcode': beforePaymentPayload?.zipcode,
		// 	'desired_start_date': moment().format('YYYY/MM/DD'),
		// 	'vehicleList': beforePaymentPayload?.vehicleList,
		// 	'is_admin': '0',
		// 	'user_id': beforePaymentPayload?.user_id ? beforePaymentPayload?.user_id : '',
		// 	'address1': beforePaymentPayload?.address1,
		// 	'address2': beforePaymentPayload?.address2 ? beforePaymentPayload?.address2 : '',
		// 	'permit_rate': beforePaymentPayload?.permit_rate,
		// 	'permit_rate_id': beforePaymentPayload?.permit_rate_id,
		// 	'payment_status': 'success',
		// 	'MerchantRef': queries?.MerchantRef ? queries?.MerchantRef : paymentSession?.reference ? paymentSession?.reference : '',
		// 	// TxID : queries?.TxID,
		// 	// CardType: queries?.CardType,
		// 	// total : paymentSession?.amount,
		// 	// TokenNo:queries?.TokenNo,
		// 	// AuthorisationCode: queries?.AuthorisationCode,

		// }

		// if (queries?.AuthorisationCode && queries?.AuthorisationCode !== null && queries?.AuthorisationCode !== '') {
		//setPaymentStatus(true)
		// dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
		// 	if (res?.data && res?.data?.message && res?.data?.message == 'Booking already done by the user.') {
		// 		navigate(`/${partner}${URL?.BASE_HOME}`)
		// 	}
		// 	setPaymentResponse(res)
		// 	setIsLoading(false)
		// 	setPaymentStatus(true)
		// 	if (res?.data && res?.data?.ticketech_code != '') {
		// 		setPaymentStatus(true)
		// 	} else {
		// 		setPaymentStatus(false)
		// 		setIsLoading(false)
		// 	}
		// 	//localStorage.clear()
		// }).catch((err) => {
		// 	if (err.ticketech_code != '') {
		// 		//localStorage.clear()
		// 	} else {
		// 		setPaymentStatus(false)
		// 		setIsLoading(false)
		// 	}
		// })
		// }
		// else {
		// 	setPaymentStatus(false)
		// 	setIsLoading(false)
		// }
		const isExistPhone = paymentResponse?.userDetails?.user?.phone_number ? paymentResponse?.userDetails?.user?.phone_number : paymentResponse?.userDetails?.phone_number ? paymentResponse?.userDetails?.phone_number : ''
		setIsPhone(isExistPhone)
	}, EMPTY_ARRAY)

	useEffect(() => {
		const getAccessPermissionData = sortPortalPermissionByKey(partnerDetials, 'Restricted Permissions')
		setAccessPermissions(getAccessPermissionData)
	}, [])



	const handleReBooking = () => {
		// if (window.location.toString().split('/')[4] == 'payment-permit-request') {
		// 	navigate(`/${partner}`)
		// }
		navigate(`/${partner}`)
		window.location.reload(true)
		// (bookingType == 'Pass') ? navigate(`/${partner}${URL?.BASE_PASSCREATE}`) : navigate(`/${partner}${URL?.BASE_HOME}`)


	}


	const handleshowVehicle = () => {
		setDisplayVehicle(!displayVehicle)
	}


	const DisplayField = (label, value) => {
		return <div className="col-6">
			<label className="floatLabel">{label}</label>
			<div className="inputBox">{value || '-'}</div>
		</div>
	}

	const mobileViewVehicleSection = (vehicleListItem = {}, vehicleListIndex, allVehicle) => {
		return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
			{DisplayField('License Plate', vehicleListItem?.license_plate_number || '-')}
			{isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicleListItem?.vehicle_type || '-') : null}
			{shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicleListItem.make || vehicleListItem.model)
				? `${vehicleListItem.make ?? ''}${allHaveMst_model && vehicleListItem.model ? ` / ${vehicleListItem.model}` : ''}`
				: '-' || '-') : null}
			{/* {is_modal_show ? DisplayField('Model', vehicleListItem?.model || '-') : null} */}
			{shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicleListItem?.color || '-') : null}
			{isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicleListItem?.style || '-') : null}

			{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicleListItem?.country || '-') : null}
			{shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicleListItem?.state_code || '-') : null}
			{isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicleListItem?.vehicle_number || '-') : null}
		</div>
	}

	const renderVehicleRow = (vehicle = {}, i, allVehicle) => {
		return (
			<tr key={i}>
				<td className="px-0">{vehicle.license_plate_number || '-'}</td>
				{isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
					<td className="px-0">{vehicle.vehicle_type || '-'}</td>
				)}
				{shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
					{(vehicle.make || vehicle.model)
						? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
						: '-'}
				</td> : null}
				{shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
				{isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
					<td className="px-0">{vehicle.style || '-'}</td>
				)}
				{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
					<td className="px-0">{vehicle.country || '-'}</td>
				)}
				{shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
				{isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
					<td className="px-0">{vehicle.vehicle_number || '-'}</td>
				)}
			</tr>
		)
	}

	const deskTopViewVehicleSection = () => {
		const refractedVehicleList = paymentResponse?.vehicleList
		return <div className='table-responsive'>
			<table className="table table-borderless table-sm mb-0">
				<thead>
					<tr>
						<th className="fw-bold px-0">License Plate</th>
						{isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_type') && (
							<th className="fw-bold px-0">Vehicle Type</th>
						)}
						{shouldShowVehicleColumn(refractedVehicleList, 'make') && shouldShowVehicleColumn(refractedVehicleList, 'model') ? <th className="fw-bold px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
						{shouldShowVehicleColumn(refractedVehicleList, 'color') ? <th className="fw-bold px-0">Color</th> : null}
						{isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(refractedVehicleList, 'style') && (
							<th className="fw-bold px-0">Style</th>
						)}
						{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(refractedVehicleList, 'country') && (
							<th className="fw-bold px-0">Country</th>
						)}
						{shouldShowVehicleColumn(refractedVehicleList, 'state_code') ? <th className="fw-bold px-0">State</th> : null}
						{isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_number') && (
							<th className="fw-bold px-0">VIN</th>
						)}
					</tr>
				</thead>

				<tbody>
					{renderVehicleRow(refractedVehicleList?.[0], 0, refractedVehicleList)}
				</tbody>

				<tbody className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
					{(refractedVehicleList?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, refractedVehicleList))}
				</tbody>
			</table>
		</div>
	}

	return (
		isLoading ? <span className='ms-2 d-flex justify-content-center'>
			<Circles
				height="500"
				width="50"
				color="var(--bs-primary)"
				ariaLabel="circles-loading"
				visible={true}
			/>
		</span> :
			<div>
				{paymentStatus && <div className="bg-white p-4 mb-3">
				</div>}
				{paymentStatus ? <div className="block">
					<h1 className="text-center text-success mb-0 fw-bold p-3">{paymentStatus ? 'Thank You!' : 'Error!'}</h1>
					{!paymentStatus && <h4 className="text-center text-danger fw-bold p-3">Booking Failed.</h4>}
					
					{searchParams?.get('permitID') ? <div className="row p-4 border border-3 bg-opacity-25 mb-3 align-items-center  m-0 p-0">
						<div className='col-12 col-sm-8'>
							<p className="text-dark h4 fw-light text-center mb-3 p-4  bg-success bg-opacity-10 ">
								<i className='fa text-success me-2 fa-check-circle'>
								</i> {paymentResponse ? 'Your Parking ' + bookingType + ' #' + paymentResponse?.account_number + ' has been created.' : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
							</p>
						</div>
						<div className="col-sm-4 col-12 text-end">
							<div className='QRCenter mb-2'>
								<QRCodeSVG
									value={paymentResponse?.account_number}
									width="150px"
									height="150px"
								/>
							</div>						
						</div>
					</div> : 
					<p className="text-dark h4 fw-light text-center mb-3 p-4  bg-success bg-opacity-10 ">
						<i className='fa text-success me-2 fa-check-circle'>
						</i> {paymentResponse ? 'Your Parking ' + bookingType + ' #' + paymentResponse?.account_number + ' has been created.' : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
					</p>}

					<div className='p-4 border border-bottom-0 border-3'>

						{paymentResponse ? <div className="">
							<h4 className='fw-semibold text-muted'>Please note the following for your reference</h4>
							<div className='bg-primary bg-opacity-10'>
								<div className='row gap-2 py-2 px-3  mb-3 g-0 border-white justify-content-between'>
									{paymentResponse?.hid_card_number ? <div className='col-sm col-12'>
										<div className="d-flex">
											<b className="nowrap me-2">PROX Card ID: </b>
											<span> {paymentResponse?.hid_card_number || '-'}</span>
										</div>
									</div> : null }
									{searchParams?.get('permitID') ? null : <div className='col-sm col-12'>
										<div className="d-flex">
											<b className="nowrap">Start Date -</b>
											<span>{moment(paymentResponse?.desired_start_date, 'YYYY/MM/DD').format('MM/DD/YYYY')}</span>
										</div>
									</div> }
									{searchParams?.get('permitID') ? null : <div className='col-sm-auto border-2 border-sm-start border-dark'>
										<div className="d-flex">
											<b className="nowrap">End Date -</b>
											<span>{moment(paymentResponse?.desired_end_date, 'YYYY/MM/DD').format('MM/DD/YYYY')}</span>
										</div>
									</div> }
								</div>
							</div>
						</div> : ''}

						<div className="px-3">
							<table className="table table-sm table-borderless tableBlockSM  table-sm">
								{paymentSession ? <tbody>
									<tr>
										<td className='fw-bold'>Name:</td>
										<td>
											{paymentResponse?.name}									</td>
										<td className='fw-bold'>Email:</td>
										<td>
											{paymentResponse?.email}								</td>
									</tr>
									<tr>
										<td className='fw-bold'>Phone Number:</td>
										<td>
											{paymentResponse?.userDetails?.user ? phoneMasker(paymentResponse?.userDetails?.user?.phone_number) : paymentResponse?.userDetails?.phone_number ? phoneMasker(paymentResponse?.userDetails?.phone_number) : '-'}
										</td>
										<td className="fw-bold">Permit Type</td>
										<td>
											<span className='text-muted me-2'>{paymentResponse?.permit_type_name}</span>
											<span className="timeValidationRes col-12 small text-primary">{paymentResponse?.rate_description?.is_hide_validity == '0' && paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</span>
											{/* {paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})`:''} */}
										</td>
										{/* <td>{paymentResponse?.permit_type_name} {paymentResponse?.rate_description?.description ? `(${paymentResponse?.rate_description?.description})` : ''}</td> */}

									</tr>
									{paymentResponse?.reserved_space_number ? <tr>
										<td className="fw-bold">Preferred Reserved Space Number</td>
										<td colSpan={3}>{paymentResponse?.reserved_space_number}</td>
									</tr> : ''}


									{paymentResponse ? <tr>
										{/* <td className="fw-bold">Permit ID</td>
								<td>{paymentResponse?.account_number}</td> */}
										{/* <td className="fw-bold">Permit Type</td>
								<td>{paymentResponse?.permit_type_name}</td> */}
									</tr>
										:
										<tr>
											<td className='fw-bold'>Reference ID</td>
											<td>
												{paymentSession?.reference}
											</td>
											<td className='fw-bold'>Transaction ID</td>
											<td>
												{queries?.TxID}
											</td>
										</tr>
									}
								</tbody> : null}
							</table>
							{paymentResponse?.permitServices?.length > 0 ? <div className='py-2 border-top'>
								<b>Permit Services(s)</b>
								{paymentResponse?.permitServices?.map((v, i) => {
									if (v?.permit_service_name != 'Select All Access') {
										return (

											<div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
												<div>
													<span className='text-muted text-capitalize me-2'>{v?.permit_service_name}</span>
													<span className="timeValidationRes small text-primary">{(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}</span>
												</div>
												{/* <div className=' text-muted text-capitalize' >
												{v?.permit_service_name}
											</div> */}
												{/* <div className='fw-semibold '>
													${v?.permit_service_rate}
												</div> */}
											</div>
										)
									}

								})}
							</div> : ''}
							{paymentResponse?.vehicleList?.length > 0 ? <div className="border-top container py-2">
								<div className="d-flex align-items-center mb-2 justify-content-between">
									<b>Vehicle(s)</b>
									{paymentResponse?.vehicleList?.length > 1 && (
										<div className='d-flex gap-2'>
											<span className='fw-bold text-primary'>
												{`${paymentResponse?.vehicleList?.length} ${paymentResponse?.vehicleList?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
											</span>
											<button
												className='btn btn-outline-dark btn-sm'
												type="button"
												data-bs-toggle="collapse"
												data-bs-target='#vehicleCollapse'
												aria-expanded={displayVehicle}
												aria-controls='vehicleCollapse'
												onClick={handleshowVehicle}
											>
												{displayVehicle ? 'Hide All' : 'View All'}
											</button>
										</div>
									)}
								</div>
								{isMobile ? <div>
									<div>
										{mobileViewVehicleSection(paymentResponse?.vehicleList?.[0], 0, paymentResponse?.vehicleList)}
									</div>

									<div className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
										{(paymentResponse?.vehicleList?.slice(1) || []).map((v, i) => mobileViewVehicleSection(v, i + 1, paymentResponse?.vehicleList))}
									</div>
								</div> : deskTopViewVehicleSection()}
							</div> : null}

							{/* card detilas  */}
							{(isZeroAmount(paymentSession?.amount) || paymentResponse?.transaction == null || isZeroAmount(paymentResponse?.transaction?.total)) ? '' :
							paymentResponse?.transaction?.payment_last_four ? <div className='py-2 border-top'>
								<Row>
									<Col><b>Card last four :</b> {`XXXXXXXXXXXX${paymentResponse?.transaction?.payment_last_four}`}</Col>
									<Col><b>Card type :</b>  <img src={getCardIcon(paymentResponse?.transaction?.card_type ? paymentResponse?.transaction?.card_type : '')} style={{ width: '30px', padding: '0' }} alt="" /></Col>
									{(paymentResponse?.transaction?.method != 'APL' && paymentResponse?.transaction?.method != 'GPAY') ? <Col><b>Card expiry:</b>{`${paymentResponse?.transaction?.expiration?.substring(0, 2)}/${paymentResponse?.transaction?.expiration?.substring(2, 4)}`}</Col> : paymentResponse?.transaction?.method == 'APL' ? <Col><span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-apple-pay fs-5'></i></span></span></Col> : paymentResponse?.transaction?.method == 'GPAY' ? <Col><span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-google-pay fs-5'></i></span></span></Col> : ''}
								</Row>
							</div> : null}
							<div className="py-2 border-top">
								<PassWalletButtons
									ticketId={paymentResponse?.account_number}
									googleWalletApi={APICONFIG.getGooglePermitPassDownload}
									appleWalletApi={APICONFIG.getapplePermitPassDownload}
									notify={notify}
									partnerDetails={partnerDetials}
								/>
							</div>
						</div>
					</div>
					{/* total Amount */}
					<div className='bg-light border border-top-0 border-3  px-4  p-2'>
						<div className="row g-0 justify-content-between"><div className="col"><b className="lead fw-bold">Total Amount</b></div><div className="col-auto"><h3 className="m-0">						
							${paymentResponse?.transaction != null && (paymentResponse?.transaction?.total || Number(paymentResponse?.transaction?.total) == 0) ? formatDecimal(paymentResponse?.transaction?.total) : paymentResponse?.permit_final_amount ? formatDecimal(paymentResponse?.permit_final_amount) : '0.00'}
						</h3></div></div>
						<div>
						</div>
					</div>

					<div className="text-success bg-opacity-25 my-3">
						{/* <p className='alert alert-success text-center' >
							{paymentResponse ? `Your e-${bookingType} details have been sent to your registered phone number ${phoneMasker(paymentResponse?.userDetails?.user ? paymentResponse?.userDetails?.user?.phone_number : paymentResponse?.userDetails?.phone_number)} & email address ${paymentResponse?.email}.` : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
						</p> */}
						<p className='alert alert-success text-center' >
							{paymentResponse ? `Your e-${bookingType} details have been sent to your ${isphone && isphone != '' ? `phone number ${phoneMasker(isphone)} &` : ''} email address ${paymentResponse?.email}.` : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}
						</p>
						{partner == 'demo-parkengage' ? <h4 className='fw-bold text-dark'>This Permit is Valid in Zone {zone} from 9 am to 3 pm<br />
							You maybe cited if Parking in Zone {zone} Outside those hours</h4> : null}
						<div className='text-center'>
							<button type="button" className="btn btn-primary mx-auto " onClick={(e) => handleReBooking(e)}>Book Another {bookingType}</button>
						</div>
					</div>
				</div> :
					<div className="  mx-auto mt-4 text-center mb-4 ">
						<h1 className="text-center text-danger fw-bold mt-3 mb-3">Booking Failed!  </h1>
						<div className='px-3 d-block py-4 fw-light pb-2 bg-danger bg-opacity-10 mb-3'>
							<p className="m-0 h5 fa-light text-danger mb-3">
								<i className='fa  text-danger fa-warning'>
								</i> {response ? response : paymentResponse?.errors?.message ? paymentResponse?.errors?.message : systemError}</p>
						</div>

						{paymentSession && Object.keys(paymentSession)?.length > 0 ? <div className='row g-0 gap-3 border-bottom border-2 py-3'>
							<b className='small d-block text-dark fw-bold' >Please note the following for your reference:</b>
							<div className='col-sm col-12'>
								<b>Amount:</b> 
									${paymentResponse?.transaction != null && (paymentResponse?.transaction?.total || Number(paymentResponse?.transaction?.total) == 0) ? formatDecimal(paymentResponse?.transaction?.total) : paymentResponse?.permit_final_amount ? formatDecimal(paymentResponse?.permit_final_amount) : formatDecimal(0)}
								</div>
							<div className='col-sm col-12'>
								<b>Reference ID:</b> {paymentSession?.reference}</div>
							<div className='col-sm col-12'>
								<b>Transaction ID:</b> {queries?.TxID}</div>

						</div> : null}

						{/* card detilas  */}
						{(CardNumberLast4 && card_type && expiration_date) ? <div className='py-2 border-bottom border-5'>

							<Row>

								<Col><b>Card last four :</b> {`XXXXXXXXXXXX${CardNumberLast4 ? removeDubleComma(CardNumberLast4) : paymentResponse?.paymentDetails?.card_last_four}`}</Col>

								<Col><b>Card type :</b>  <img src={getCardIcon(card_type ? removeDubleComma(card_type) : paymentResponse?.transaction?.card_type ? paymentResponse?.transaction?.card_type : '')} style={{ width: '30px', padding: '0' }} alt="" /> {removeDubleComma(card_type)}</Col>
								{(paymentResponse?.transaction?.method != 'APL' && paymentResponse?.transaction?.method != 'GPAY') ? <Col><b>Card expiry:</b>{(expiration_date) ? `${removeDubleComma(expiration_date)?.toString()?.substring(0, 2)}/${removeDubleComma(expiration_date)?.toString()?.substring(2, 4)}` : `${paymentResponse?.transaction?.expiry?.toString()?.substring(0, 2)}/${paymentResponse?.transaction?.expiry?.toString()?.substring(2, 4)}`}</Col> : paymentResponse?.transaction?.method == 'APL' ? <Col><span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-apple-pay fs-5'></i></span></span></Col> : paymentResponse?.transaction?.method == 'GPAY' ? <Col><span className='badge bg-dark small rounded-5 fw-light'><span className='d-flex align-items-center gap-1'>Paid by: <i className='fa-brands fa-google-pay fs-5'></i></span></span></Col> : '' }
							</Row>
						</div> : ''}
						<button type="button" className="btn btn-primary my-4 " onClick={(e) => handleReBooking(e)}>Book Another {bookingType}</button>
					</div>}
			</div>
	)

}

ThankYou.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	events: PropTypes.object,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
	setPage: PropTypes.string,
	response: PropTypes.object,
	paymentStatus: PropTypes.bool,
	paymentResponse: PropTypes.object,
	isLoading: PropTypes.bool,
	notify: PropTypes.func
}

ThankYou.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	events: EMPTY_OBJECT,
	loader: true,
	getCard: noop,
	passData: EMPTY_ARRAY,
	setPage: undefined,
	response: EMPTY_OBJECT,
	paymentStatus: false,
	paymentResponse: EMPTY_OBJECT,
	isLoading: true,
	notify: noop
}

function mapStateToProps({ paymentReducer }) {
	return {
		data: paymentReducer,
	}
}
export default connect(mapStateToProps)(ThankYou)
